import { CommonHeader } from '~/components';
import styles from './Logout.module.scss';
import { useEffect } from 'react';
import authApi from '~/api/authApi';
import { isSuccess } from '~/utils/api';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import { actions, useStore } from '~/store';

function Logout() {
    const navigate = useNavigate();
    const [, dispatch] = useStore();
    const handleLogoutOk = () => {
        localStorage.removeItem('username');
        localStorage.removeItem('accessToken');
        localStorage.removeItem('refreshToken');
        localStorage.removeItem('tripId');
        localStorage.removeItem('tripName');
        dispatch(actions.setLoading({ loading: false }));
        navigate(`/login`);
    };
    useEffect(() => {
        dispatch(actions.setLoading({ loading: true }));
        const browserId = localStorage.getItem('browserId');
        const username = localStorage.getItem('username');
        if (!!browserId && !!username) {
            authApi
                .logout({ username, browserId })
                .then((res) => {
                    // console.log('res', res);
                    if (isSuccess(res)) {
                    } else {
                        toast.error(res.data);
                    }
                    handleLogoutOk();
                })
                .catch((error) => {
                    console.log(error);
                    toast.error(JSON.stringify(error));
                    handleLogoutOk();
                });
        } else {
            handleLogoutOk();
        }
        // eslint-disable-next-line
    }, []);

    return (
        <div className={styles.wrapper}>
            <CommonHeader title={'Đăng xuất'} />
        </div>
    );
}

export default Logout;
